<div class="common-background">
    <div
        class="flex align-items-center justify-content-center min-h-screen min-w-screen overflow-hidden"
    >
        <div class="auth-wrapper">
            <div>
                <div class="logo-wrap">
                    <img src="../../../../assets/img/logo-dark.svg" alt="" />
                </div>
                <div
                    class="login-body w-full surface-card py-6 px-3 sm:px-6 rounded-10"
                >
                    <router-outlet></router-outlet>
                </div>
                @if(isLoginPage()) {
                <div class="privacy-policy-wrapper">
                    <span class="policy-text">
                        By clicking Log In, you agree to our
                        <b
                            (click)="openTermsAndConditions()"
                            class="policy-link"
                            >Terms and conditions</b
                        >.
                    </span>
                    <span class="policy-text">
                        Check how we process your data in our
                        <b (click)="openPrivacyPolicy()" class="policy-link"
                            >Privacy Policy</b
                        >.
                    </span>
                </div>
                }
            </div>
        </div>
    </div>
</div>

<app-popup
    [visible]="popup.privacy || popup.terms"
    (closeModel)="closePopup()"
    (emitSubmit)="closePopup()"
    [title]="popup.privacy ? 'Privacy Policy' : 'Terms & Conditions'"
    [showSubmitBtn]="true"
    [isDeletedPopup]="true"
    [submitButtonText]="commonLabels.ok"
    [cancelButtonText]="commonLabels.cancel"
>
    <div class="mb-4">
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nam tempora
        unde laudantium soluta dolores! Est nesciunt beatae maiores tenetur
        distinctio nobis incidunt vel. Provident autem optio id, hic quam
        maiores! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nam
        tempora unde laudantium soluta dolores! Est nesciunt beatae maiores
        tenetur distinctio nobis incidunt vel. Provident autem optio id, hic
        quam maiores! Lorem ipsum dolor sit amet, consectetur adipisicing elit.
        Nam tempora unde laudantium soluta dolores! Est nesciunt beatae maiores
        tenetur distinctio nobis incidunt vel. Provident autem optio id, hic
        quam maiores! Lorem ipsum dolor sit amet, consectetur adipisicing elit.
        Nam tempora unde laudantium soluta dolores! Est nesciunt beatae maiores
        tenetur distinctio nobis incidunt vel. Provident autem optio id, hic
        quam maiores! Lorem ipsum dolor sit amet, consectetur adipisicing elit.
        Nam tempora unde laudantium soluta dolores! Est nesciunt beatae maiores
        tenetur distinctio nobis incidunt vel. Provident autem optio id, hic
        quam maiores! Lorem ipsum dolor sit amet, consectetur adipisicing elit.
        Nam tempora unde laudantium soluta dolores! Est nesciunt beatae maiores
        tenetur distinctio nobis incidunt vel. Provident autem optio id, hic
        quam maiores! Lorem ipsum dolor sit amet, consectetur adipisicing elit.
        Nam tempora unde laudantium soluta dolores! Est nesciunt beatae maiores
        tenetur distinctio nobis incidunt vel. Provident autem optio id, hic
        quam maiores! Lorem ipsum dolor sit amet, consectetur adipisicing elit.
        Nam tempora unde laudantium soluta dolores! Est nesciunt beatae maiores
        tenetur distinctio nobis incidunt vel. Provident autem optio id, hic
        quam maiores! Lorem ipsum dolor sit amet, consectetur adipisicing elit.
        Nam tempora unde laudantium soluta dolores! Est nesciunt beatae maiores
        tenetur distinctio nobis incidunt vel. Provident autem optio id, hic
        quam maiores!
    </div>
</app-popup>
